import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const TerminateComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="解約申込完了" content="解約申込が完了しました。"  />
      </Layout>
    </React.Fragment>
  )
}

export default TerminateComplete;